import { render, staticRenderFns } from "./PixPdf.vue?vue&type=template&id=a93fcef4"
import script from "./PixPdf.vue?vue&type=script&lang=js"
export * from "./PixPdf.vue?vue&type=script&lang=js"
import style0 from "./PixPdf.vue?vue&type=style&index=0&id=a93fcef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports